import { PartyPopper, ArrowRight } from 'lucide-react';
import { useBodyScrollLock } from '../../hooks/useBodyScrollLock';

export function CelebratePhase({ typeLabel, onClose }) {
  useBodyScrollLock();
  return (
    <div className="fixed inset-0 z-50 overflow-y-auto" style={{ background: 'rgba(11,14,20,0.26)', backdropFilter: 'blur(8px)' }}>
      <div className="flex min-h-full items-center justify-center px-4 py-8" onClick={onClose}>
      <div className="completion-celebrate-container" onClick={(e) => e.stopPropagation()}>
        <div className="completion-confetti-burst" />
        <div className="completion-celebrate-content animate-scale-in">
          <div className="completion-check-ring">
            <svg viewBox="0 0 52 52" className="completion-check-svg">
              <circle className="completion-check-circle" cx="26" cy="26" r="24" fill="none" />
              <path className="completion-check-mark" d="M14 27l8 8 16-16" fill="none" />
            </svg>
          </div>
          <h3 className="text-lg font-semibold mt-4" style={{ color: 'var(--pd-text)' }}>Done!</h3>
          <p className="text-sm mt-1" style={{ color: 'var(--pd-muted)' }}>{typeLabel} completed</p>
        </div>
      </div>
      </div>
    </div>
  );
}

export function AskPhase({ sourceTitle, onNo, onYes, onClose }) {
  useBodyScrollLock();
  return (
    <div className="fixed inset-0 z-50 overflow-y-auto" style={{ background: 'var(--pd-overlay)', backdropFilter: 'blur(8px)' }}>
      <div className="flex min-h-full items-center justify-center px-4 py-8" onClick={onClose}>
      <div className="w-full max-w-[420px] rounded-[28px] animate-fade-in overflow-hidden" style={{ background: 'var(--pd-popover)', border: '1px solid var(--pd-popover-border)', boxShadow: 'var(--pd-shadow-3)' }} onClick={(e) => e.stopPropagation()}>
        <div className="p-6 text-center">
          <div className="w-12 h-12 mx-auto rounded-2xl flex items-center justify-center mb-4" style={{ background: 'var(--pd-green-soft)' }}>
            <PartyPopper className="w-5 h-5" style={{ color: 'var(--pd-success)' }} />
          </div>
          <h3 className="text-base font-semibold" style={{ color: 'var(--pd-text)' }}>
            "{sourceTitle}" completed
          </h3>
          <p className="text-[13px] mt-2 mb-6" style={{ color: 'var(--pd-muted)', lineHeight: 1.7 }}>
            Any follow-up action needed?
          </p>
          <div className="flex gap-2">
            <button data-testid="followup-no-btn" onClick={onNo}
              className="flex-1 px-4 py-3 rounded-[16px] text-[13px] font-medium transition-colors"
              style={{ background: 'var(--pd-panel-2)', color: 'var(--pd-muted)' }}>
              No, all done
            </button>
            <button data-testid="followup-yes-btn" onClick={onYes}
              className="flex-1 flex items-center justify-center gap-2 px-4 py-3 rounded-[16px] text-[13px] font-semibold text-white transition-colors"
              style={{ background: 'var(--pd-focus)' }}>
              Create follow-up <ArrowRight className="w-3.5 h-3.5" />
            </button>
          </div>
        </div>
      </div>
      </div>
    </div>
  );
}
